module.exports = __webpack_public_path__ + "img/abris.7a47ba59.jpg";